<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
			<div class="r">
				<el-button type='primary' @click="editing = true">修改个人信息</el-button>
			</div>
		</div>
		<div class="center_bodyCont">
			<div class="center_infoList">
				<span class="center_infoLabel">头像</span>
				<div class="center_infoIcon">
					<img :src='baseurl + userinfo.iconurl' v-if="userinfo.iconurl" />
					<img src='@/images/1.png' v-else />
				</div>
			</div>
			<div class="center_infoList">
				<span class="center_infoLabel">姓名</span>
				<div class="center_infoText">
					{{userinfo.name}}
				</div>
			</div>
			<div class="center_infoList">
				<span class="center_infoLabel">性别</span>
				<div class="center_infoText">
					{{userinfo.sex == '1'?'女':'男'}}
				</div>
			</div>
			<div class="center_infoList">
				<span class="center_infoLabel">学号</span>
				<div class="center_infoText">
					{{userinfo.username}}
				</div>
			</div>
			<div class="center_infoList">
				<span class="center_infoLabel">年级</span>
				<div class="center_infoText">
					{{userinfo.deptName}}
				</div>
			</div>
			<div class="center_infoList">
				<span class="center_infoLabel">手机号</span>
				<div class="center_infoText">
					{{userinfo.mobile || '无'}}
				</div>
			</div>
			<el-dialog title="修改个人信息" class="open_dialogInfo" :visible.sync="editing" :append-to-body='true' width="450px" :close-on-click-modal='false' :close-on-press-escape='false' :show-close='false'>
				<div class="center_edit">
					<el-form :model="addForm" :rules="rules" ref="addForm" label-width="100px" class="center_editForm">
						<el-form-item label="姓名" prop="name">
							<el-input v-model="addForm.name" style='width: 300px;'></el-input>
						</el-form-item>
						<el-form-item label="性别" prop="sex">
							<el-radio-group v-model="addForm.sex">
								<el-radio :label="0" class="per_radio">男</el-radio>
								<el-radio :label="1" class="per_radio">女</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="手机号" prop="mobile">
							<el-input v-model="addForm.mobile" style='width: 300px;'></el-input>
						</el-form-item>
						<el-form-item label="头像" prop="iconurl">
							<div class="center_headBox">
								<el-upload class="center_headEdit" action="#" accept=".jpg,.png,.jpeg" :http-request="handleFileUpload" :show-file-list="false">
									<div class="center_headEditClick">
										<div v-if="!addForm.iconurl"><i class="el-icon-plus"></i></div>
										<img :src='baseurl + addForm.iconurl' v-else/>
									</div>
								</el-upload>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="center_btns">
					<el-button type='info' @click="resetForm()">取消</el-button>
					<el-button type='primary' @click="submitForm()">保存</el-button>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import { updateUser, getInfo } from '@/api/user.js'
	import { deptList } from '@/api/sysDept.js'
	import { putProgress } from "@/utils/oss.js"
	import { removeToken, removeStorageToken } from '@/utils/auth'
	export default {
		data() {
			var validatorphone = (rule, value, cadd_backimg) => {
				let reg = /^1[3456789]\d{9}$/;
				if(!reg.test(value)) {
					cadd_backimg(new Error('请输入正确的手机号码'))
				} else {
					cadd_backimg()
				}
			};
			return {
				activeName: '1',
				commNavs: [{
					name: '基本信息',
					id: '1'
				}],
				//标签页
				editing: false,
				depts: [],
				tabPosition: 'left',
				userinfo: {},
				props: {
					checkStrictly: true,
					value: 'id',
					label: 'text',
				},
				//表单
				addForm: {
					iconurl: '',
					name: '',
					sex: '',
					mobile: '',
					userId: '',
				},
				rules: {
					name: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					}],
					sex: [{
						required: true,
						message: '请选择性别',
						trigger: 'change'
					}],
				}
			};
		},
		created() {
			this.getMyInfo();
			this.getDeptList();
		},
		methods: {
			handleFileUpload(option) {
				const {
					file
				} = option;
				var userId = this.userinfo.userId
				const suffix = file.name.slice(file.name.lastIndexOf("."));
				const key = `vr/stuIcon/${userId}/${this.createUUID()}${suffix}`;
				putProgress(key, file, (progress, checkpoint) => {
					if(checkpoint) {
						this.coverFlag = true;
						this.coverProgress = Math.round(progress * 100);
					}
				}).then(res => {
					this.$set(this.addForm, 'iconurl', key);
					this.coverFlag = false;
					this.coverProgress = 0;
				});
			},
			getMyInfo() {
				getInfo().then(res => {
					this.userinfo = res.data;
					this.addForm = {
						iconurl: res.data.iconurl,
						name: res.data.name,
						sex: res.data.sex,
						mobile: res.data.mobile,
						userId: res.data.userId,
					};
				})
			},
			getDeptList() {
				deptList({}).then(async res => {
					this.depts = res.children
				})
			},
			submitForm() {
				this.$refs.addForm.validate((valid) => {
					if(valid) {
						var data = {
							userId: this.addForm.userId,
							iconurl: this.addForm.iconurl,
							name: this.addForm.name,
							sex: this.addForm.sex,
							mobile: this.addForm.mobile,
						}
						updateUser(data).then(res => {
							if(res.code == 'OK') {
								this.$alert('修改成功，请重新登陆！', '提示', {
									confirmButtonText: '确定',
									type: 'warning'
								}).then(() => {
									removeToken();
									removeStorageToken();
									location.reload()
								}).catch(() => {
									removeToken();
									removeStorageToken();
									location.reload()
								})
							} else {
								this.$message({
									type: "error",
									message: res.msg
								})
							}
						})
					}
				});
			},
			resetForm() {
				this.$refs.addForm.resetFields();
				this.$refs.addForm.clearValidate()
				this.getMyInfo();
				this.editing = false;
			},
			createUUID() {
				return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
					let r = (Math.random() * 16) | 0,
						v = c == "x" ? r : (r & 0x3) | 0x8;
					return v.toString(16);
				});
			},
		}
	}
</script>

<style>

</style>